/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Wh_SortingInputs */

const vi_sinp_wh_sorting = /** @type {(inputs: Sinp_Wh_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho phân loại`)
};

/**

* @param {Sinp_Wh_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_wh_sorting = /** @type {((inputs?: Sinp_Wh_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Wh_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_wh_sorting(inputs)
});